import { stateSchema } from "@redotech/redo-platform-common/geographic-unit";
import * as z from "zod";

export const getStates = {
  name: "getStates" as const,
  description:
    "States or provinces within one country, for a location condition's prerequisite values.",
  mutates: false,
  input: z.object({ countryCode: z.string() }),
  output: z.array(stateSchema),
};
